module.exports = __webpack_public_path__ + "img/80.d800e4e8.jpg";